<template lang="pug">
.po
  .poBlock
    //- 封面照片
    ImgLoader.poPic(
      :img="showPost.cover_photo"
      :alt="'cover_photo'"
      :style="{'--bgImgPos': 'center'}"
    )
    //- 標題
    .poTitle {{ showPost.title }}
    .poSubTitle
      //- 日期
      .poDate {{ showPost.publish_time.slice(0, 10) }}
      //- 作者
      .poAuthor {{ showPost.author.name }}
    //- 影片
    //- .poVideo(v-html="showPost.video" v-if="showPost.video")
    //- 文字內容
    .poContent(v-html="showPost.body")
    //- tags 
    .poTag
      .poTagText(v-for="tag in showPost.tags") # {{ tag.name }}
</template>

<script>
import { ok, warn } from '@/utils/msg'
import { fetchPortalBlockData } from '@/api/client/Project';

import { fetchArticle } from '@/api/client/Articles'
export default {
  data() {
    return {
      showPost: {
        cover_photo: '',
        title: '',
        media: null,
        author: {
          name: '',
          id: null
        },
        body: '',
        video: null,
        publish_time: '',
        tags: []
      },
    }
  },
  async created() {
    const { dbId } = this.$route.query
    const { postid: postId } = this.$route.params
    if (await this.isFromBlockData(postId)) return
    await this.fetchPost(postId, dbId || 2)
  },
  methods: {
    async isFromBlockData(postId) {
      try {
        const { data } = await fetchPortalBlockData()
        const { bulletin, activity_results, activity_news } = data
        const targetData = [
          ...bulletin,
          ...activity_results,
          ...activity_news
        ].find(e => e.id === postId)
        if (!targetData) throw new Error('isFromBlockData: no data')
        this.showPost = {
          ...this.showPost,
          ...targetData
        }
        return true
      } catch (err) {
        // console.warn(err)
        return false
      }
    },
    async fetchPost(postId, dbId) {
      try {
        const { data } = await fetchArticle(postId, dbId)
        if (data == null) throw new Error('fetchPost')
        this.showPost = data
      } catch (err) {
        console.warn(err)
        this.showPost.title = '找不到資料'
        warn('找不到資料, 將返回上一頁')
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/assets/style.sass'

iframe
  +pad
    width: 100%
  +phone
    width: 100%
    height: 55vw
    
img
  +pad
    width: 100%
    height: auto

    +phone
    width: 100%
    height: auto
.po
  width: 100%
  box-sizing: border-box
  margin-top: 5vw
  padding: 0 0 300px 0
  +pad
    margin-top: 2vw
    padding: 0 0 150px 0
  +phone
    // margin-top: 2vw
    padding: 0 0 520px 0

  .poBlock
    width: 80%
    margin-left: 10%
    +phone
      width: 95%
      margin-left: 2.5%
    //封面照片
    .poPic
      width: 100%
      height: 50vw

      +pad
        height: 45vw
      +phone
        height: 70vw
    //標題
    .poTitle
      font-size: 35px
      font-weight: 800
      line-height: 60px
      letter-spacing: 2px
      color: #878787
      padding: 1.5vw 0 1vw 0
      +pad
        // font-size: 3.5vw
      +phone
        // font-size: 5.5vw
        font-size: 25px
        line-height: 40px
    .poSubTitle
      +flexrow
      // +bb
      margin-top: 10px
      margin-bottom: 30px
      color: black
      +phone
        +flexcolumn
        margin-top: 2vw
      //日期
      .poDate
        font-size: 15px
        // color: #878787
        letter-spacing: 2px
        +pad
          // font-size: 2vw
          // letter-spacing: 0.2vw
        +phone
          // font-size: 3.8vw
          // margin-top: 1vw
      //作者
      .poAuthor
        font-size: 15px
        // color: #878787
        margin-left: 2%
        letter-spacing: 2px
        +pad
          // font-size: 2vw
          // letter-spacing: 0.3vw
        +phone
          // font-size: 3.8vw
          margin-left: 0
          margin-top: 1vw


    //影片
    .poVideo
      margin-top: 2vw
      margin-bottom: 2vw
      +phone
        width: 100%
        height: auto
    //文字內容
    .poContent
      border-bottom: solid 1px #878787
      line-height: 45px
      letter-spacing: 2px
      font-size: 20px
      color: #878787
      +pad
        // line-height: 5vw
        word-break: break-all
      +phone
        // line-height: 10vw
        // font-size: 4.3vw
        font-size: 18px
      
    //#
    .poTag
      +flexrow
      padding: 1.5vw 0 0 0
      .poTagText
        font-size: 1vw
        color: #878787
        margin-right: 1vw
        +pad
          font-size: 2vw
        +phone
          font-size: 4.3vw

  //推薦
  .poResTitle
    width: 80%
    margin-left: 10%
    font-size: 1.5vw
    // font-weight: 800
    margin-top: 2%
    +pad
      font-size: 2.5vw
    +phone
      width: 95%
      margin-left: 2.5%
      font-size: 5vw
      font-weight: 800
  .poRes
    width: 80%
    margin-left: 10%
    +flexrow
    +phone
      +flexcolumn
      width: 95%
      margin-left: 2.5%
    .Res
      width: 25%
      height: 20vw
      margin-right: 2vw
      margin-top: 2vw
      position: relative
      +pad
        width: 33%
      +phone
        width: 100%
        height: 80vw
      &:hover
        .block
          opacity: 1
          transition: 0.5s
      .block
        width: 100%
        height: 100%
        background-color: rgba(#333,0.7)
        // font-weight: 800
        // line-height: 200%
        +flexcolumn
        align-items: center
        justify-content: center
        opacity: 0
        transition: 0.5s
        +pad
          opacity: 1
          height: 40%
          bottom: 0
          position: absolute

        .text
          width: 95%
          font-size: 1.5vw
          color: white
          font-weight: 800
          text-align: center
          line-height: 2.3vw
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          // +bb
          height: 23%
          +pad
            height: 60%
            line-height: 2.5vw
          +phone
            font-size: 6vw
            line-height: 8vw
            height: 47%
            letter-spacing: 0.8vw
</style>


// WEBPACK FOOTER //
// src/views/Post/Post.vue